import React from 'react';
import { isPast, differenceInCalendarDays } from 'helpers/dates';
import { SystemText } from '@salesperformanceint/e4shared';
import Panel from 'components/general/panel';
import FocusTile from 'views/user/1-2-1s/components/performanceDashboard/components/focusTile';

export const Pathway = ({ focus, data, setShow }) => {
    if (!data) {
        return null;
    }

    const isArray = Array.isArray(data);

    if (isArray && data.length === 0) {
        return null; // No data to display
    }

    let message;
    let url;
    let colour;
    let dateDue;

    if (isArray) {
        const st = (path, ...rest) => SystemText(`Home/Widgets/WhatsHappening/Pathway/${path}`, ...rest);

        const total = data.length;
        const overdue = data.filter(s => isPast(s.date_Due)).length;

        const slug = `Outstanding${overdue > 0 ? 'Overdue' : ''}${
            overdue === 1 && total === 1 ? 'Only' : overdue === 1 ? 'One' : overdue === total ? 'All' : 'Some'
        }`;

        message = st(slug, total, overdue);
        colour = overdue > 1 ? 'danger' : 'information';
    } else {
        // handle the single item so not an array
        dateDue = data.date_Due;

        url = `/develop/pathways/${data.profile_Id}?id=${data.id}`;

        if (differenceInCalendarDays(dateDue, new Date()) < 0) {
            colour = 'danger';
            message = SystemText('Home/Widgets/WhatsHappening/Pathway/Late', data.name);
        } else {
            colour = 'information';
            message = SystemText('Home/Widgets/WhatsHappening/Pathway', data.name);
        }

        if (focus) {
            return (
                <FocusTile
                    tileType="pathway"
                    colour={colour === 'information' ? 'blue' : 'red'}
                    icon={colour === 'information' ? 'fa-user-check' : 'fa-warning'}
                    date={dateDue}
                    buttonText={colour === 'information' ? 'View' : 'Continue'}
                    message={message}
                    url={url}
                />
            );
        }
    }

    return <Panel colour={colour} icon="user-check" message={message} url={url} setShow={setShow} />;
};

export default Pathway;
